import { render, staticRenderFns } from "./TaskTagEdit.vue?vue&type=template&id=05836d2e&"
import script from "./TaskTagEdit.vue?vue&type=script&lang=js&"
export * from "./TaskTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports